<template>
    <div class="container mx-auto px-2 py-4">
        <h1>Webinar</h1>
    </div>
</template>

<script>
export default {
name: "Webinar"
}
</script>

<style scoped>

</style>
